// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu .app .main-header .editable {
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-style: dotted;
  border-radius: 10px;
}
.menu .app .main-header .top-header {
  position: absolute;
  top: 3%;
  left: 0;
  padding: 3% 6% 5%;
  z-index: 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.menu .app .main-header .top-header .button {
  width: 9%;
  cursor: pointer;
  text-decoration: none;
  font-size: 3em;
  display: flex;
}
.menu .app .main-header .top-header .button.theme {
  background-color: #caa36c;
  padding: 5px;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-self: center;
}
.menu .app .main-header .top-header .button.theme span {
  color: white;
  font-size: 0.8em;
}
.menu .app .main-header .top-header .back {
  text-decoration: none;
  display: flex;
  align-items: flex-start;
}
.menu .app .edit {
  position: absolute;
  max-width: 16px;
  /*width: 6vw;*/
  right: 6%;
  top: 6%;
  cursor: pointer;
  text-decoration: none;
}
.menu .app .edit span.icon-edit {
  color: white;
  font-size: 1.6em;
}
.menu .app .edit img {
  width: 100%;
}
.menu .app.opened .tabs {
  min-height: 290px;
  margin-top: -19%;
}
.menu .app .icons {
  min-height: 290px;
  width: 100%;
  margin: 0;
}
.menu .app .icons li.publish {
  width: 100%;
}
.menu .app .icons li.publish .button {
  cursor: pointer;
}
.menu .app .icons li.publish .button a {
  border: 2px solid #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
  margin: 10% 2% 0;
}
.menu .app .icons li.publish .button a span {
  font: 1.9em/1 vigaregular;
  color: white;
}
.menu .app .icons li .new {
  background-color: #fff;
}
.menu .app .icons li .new .button span {
  color: #caa36c;
}
.menu .app .icons li .new .cross {
  max-height: 36px;
  max-width: 36px;
  margin: 0 auto 15px auto;
  height: 14vw;
  width: 14vw;
  border-color: #caa36c;
}
.menu .app .icons li .new .cross:before, .menu .app .icons li .new .cross:after {
  transform: translate(-50%, -50%);
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
}
.menu .app .icons li .new .cross:before {
  height: 100%;
  border-left: 2px solid #caa36c;
  border-color: inherit;
}
.menu .app .icons li .new .cross:after {
  width: 100%;
  border-bottom: 2px solid #caa36c;
  border-color: inherit;
}
.menu .app .icons li .edit {
  right: 10%;
  top: 10%;
}
.menu .app .publish {
  width: 100%;
}
.menu .app .publish .button {
  cursor: pointer;
}
.menu .app .publish .button a {
  border: 2px solid #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
  margin: 5% 6%;
}
.menu .app .publish .button a span {
  font: 1.9em/1 vigaregular;
  color: white;
}
.menu .app .rec-slider-container {
  margin: 0;
}
.menu .app .rec.rec-pagination {
  margin-top: 0;
  padding-bottom: 4%;
}
.menu .app .rec.rec-pagination .rec-dot {
  background: #caa36c;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  box-shadow: none;
  font-size: inherit;
  padding: 0;
  opacity: 0.3;
}
.menu .app .rec.rec-pagination .rec-dot.rec-dot_active {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminMenu.scss"],"names":[],"mappings":"AAGY;EACI,0CAAA;EACA,oBAAA;EACA,mBAAA;AAFhB;AAKY;EACI,kBAAA;EACA,OAAA;EACA,OAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EAEA,aAAA;EACA,8BAAA;EACA,kBAAA;AAJhB;AAUgB;EACI,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;AARpB;AAUoB;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AARxB;AASwB;EACI,YAAA;EACA,gBAAA;AAP5B;AAWgB;EACI,qBAAA;EACA,aAAA;EACA,uBAAA;AATpB;AAcQ;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,qBAAA;AAZZ;AAcY;EACI,YAAA;EACA,gBAAA;AAZhB;AAeY;EACI,WAAA;AAbhB;AAkBY;EACI,iBAAA;EACA,gBAAA;AAhBhB;AAoBQ;EACI,iBAAA;EACA,WAAA;EACA,SAAA;AAlBZ;AAqBgB;EACI,WAAA;AAnBpB;AAqBoB;EACI,eAAA;AAnBxB;AAqBwB;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnB5B;AAqB4B;EACI,yBAAA;EACA,YAAA;AAnBhC;AAyBgB;EACI,sBAAA;AAvBpB;AAyBoB;EACI,cAAA;AAvBxB;AA0BoB;EACI,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AAxBxB;AA0BwB;EAEI,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AAzB5B;AA4BwB;EACI,YAAA;EACA,8BAAA;EACA,qBAAA;AA1B5B;AA6BwB;EACI,WAAA;EACA,gCAAA;EACA,qBAAA;AA3B5B;AAgCgB;EACI,UAAA;EACA,QAAA;AA9BpB;AAmCQ;EACI,WAAA;AAjCZ;AAmCY;EACI,eAAA;AAjChB;AAmCgB;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAjCpB;AAmCoB;EACI,yBAAA;EACA,YAAA;AAjCxB;AAsCQ;EACI,SAAA;AApCZ;AAsCQ;EACI,aAAA;EACA,kBAAA;AApCZ;AAqCY;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAnChB;AAoCgB;EACI,UAAA;AAlCpB","sourcesContent":[".menu {\n    .app {\n        .main-header {\n            .editable {\n                border: 1px solid rgba(255, 255, 255, 0.3);\n                border-style: dotted;\n                border-radius: 10px;\n            }\n\n            .top-header {\n                position: absolute;\n                top: 3%;\n                left: 0;\n                padding: 3% 6% 5%;\n                z-index: 2;\n                width: 100%;\n\n                display: flex;\n                justify-content: space-between;\n                align-items: start;\n\n                // .menu-logo {\n                //     width: 21%;\n                // }\n\n                .button {\n                    width: 9%;\n                    cursor: pointer;\n                    text-decoration: none;\n                    font-size: 3em;\n                    display: flex;\n\n                    &.theme{\n                        background-color: #caa36c;\n                        padding: 5px;\n                        border-radius: 6px;\n                        width: 36px;\n                        height: 36px;\n                        display: flex;\n                        align-self: center;\n                        span{\n                            color: white;\n                            font-size: 0.8em;\n                        }\n                    }\n                }\n                .back {\n                    text-decoration: none;\n                    display: flex;\n                    align-items: flex-start;\n                }\n            }\n        }\n\n        .edit {\n            position: absolute;\n            max-width: 16px;\n            /*width: 6vw;*/\n            right: 6%;\n            top: 6%;\n            cursor: pointer;\n            text-decoration: none;\n\n            span.icon-edit{\n                color: white;\n                font-size: 1.6em;\n            }\n\n            img {\n                width: 100%;\n            }\n        }\n        &.opened{\n\n            .tabs {\n                min-height: 290px;\n                margin-top: -19%;\n            }\n        }\n\n        .icons {\n            min-height: 290px;\n            width: 100%;\n            margin: 0; //check if it's being used somewhere else\n\n            li {\n                &.publish {\n                    width: 100%;\n\n                    .button {\n                        cursor: pointer;\n\n                        a {\n                            border: 2px solid #caa36c;\n                            text-decoration: none;\n                            text-align: center;\n                            border-radius: 5px;\n                            padding: 7% 0 7%;\n                            display: block;\n                            margin: 10% 2% 0;\n\n                            span {\n                                font: 1.9em/1 vigaregular;\n                                color: white;\n                            }\n                        }\n                    }\n                }\n\n                .new {\n                    background-color: #fff;\n\n                    .button span {\n                        color: #caa36c;\n                    }\n\n                    .cross {\n                        max-height: 36px;\n                        max-width: 36px;\n                        margin: 0 auto 15px auto;\n                        height: 14vw;\n                        width: 14vw;\n                        border-color: #caa36c;\n\n                        &:before,\n                        &:after {\n                            transform: translate(-50%, -50%);\n                            position: absolute;\n                            content: \"\";\n                            left: 50%;\n                            top: 50%;\n                        }\n\n                        &:before {\n                            height: 100%;\n                            border-left: 2px solid #caa36c;\n                            border-color: inherit;\n                        }\n\n                        &:after {\n                            width: 100%;\n                            border-bottom: 2px solid #caa36c;\n                            border-color: inherit;\n                        }\n                    }\n                }\n\n                .edit {\n                    right: 10%;\n                    top: 10%;\n                }\n            }\n        }\n\n        .publish {\n            width: 100%;\n\n            .button {\n                cursor: pointer;\n\n                a {\n                    border: 2px solid #caa36c;\n                    text-decoration: none;\n                    text-align: center;\n                    border-radius: 5px;\n                    padding: 7% 0 7%;\n                    display: block;\n                    margin: 5% 6%;\n\n                    span {\n                        font: 1.9em/1 vigaregular;\n                        color: white;\n                    }\n                }\n            }\n        }\n        .rec-slider-container {\n            margin: 0;\n        }\n        .rec.rec-pagination {\n            margin-top: 0;\n            padding-bottom: 4%;\n            .rec-dot {\n                background: #caa36c;\n                border-radius: 50%;\n                width: 10px;\n                height: 10px;\n                box-shadow: none;\n                font-size: inherit;\n                padding: 0;\n                opacity: 0.3;\n                &.rec-dot_active {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
